import { css } from '@emotion/react';

import { colors } from '../../../../configs';

export const contentStyles = css`
  border-radius: 0 0 8px 8px;
  background-color: ${colors.WHITE};
`;

export const cardBodyStyles = css`
  padding: 36px 72px 32px 72px;
  border-bottom: 1px solid rgba(29, 61, 113, 0.05);
`;

export const formRowStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 32px 0 0 0;

  &:first-of-type {
    margin: 0;
  }
`;

export const marginLeftStyles = css`
  margin: 0 0 0 18px;
`;

export const reactSelectContainerStyles = css`
  width: 100%;
`;

export const reactSelectLabelStyles = css`
  font-weight: 500;
  text-transform: capitalize;
`;

export const reactSelectDescriptionStyles = css`
  margin: 8px 0 0 0;
  font-size: 12px;
`;

export const reactSelectStyles = css`
  width: 100%;
  margin: 8px 0 0 0;
  z-index: 500;

  .select__control {
    padding: 5px 0;
    border: 1px solid ${colors.GREY};
    border-radius: 8px;
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
      border-color: ${colors.LIGHT_BLUE};
    }

    .select__indicator-separator {
      background-color: ${colors.GREY};
    }

    .select__indicator {
      color: ${colors.LIGHT_BLUE};
    }

    .select__value-container {
      .select__placeholder {
        padding: 0 10px;
        text-transform: capitalize;
        font-size: 14px;
        color: ${colors.GREY};
      }
    }
  }
`;

export const availabilityStatusCheckboxContainerStyles = css`
  margin: 32px 0 0 0;
`;

export const availabilityStatusCheckboxLabelStyles = css`
  font-weight: 500;
  text-transform: capitalize;
`;

export const availabilityStatusCheckboxStyles = css`
  margin: 12px 0 0 0;
`;

export const currencyAndSalaryContainerStyles = css`
  margin: 32px 0 0 0;
`;

export const salaryLabelContainerStyles = css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const salaryLabelStyles = css`
  text-transform: capitalize;
  font-weight: 500;
`;

export const salaryLabelDescriptionStyles = css`
  text-transform: capitalize;
  font-weight: 500;
  color: ${colors.GREY};
`;

export const currencyAndSalaryFieldContainerStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 0 0 0;
`;

export const selectCurrencyStyles = css`
  width: 20%;
`;

export const currencyInputStyles = css`
  width: 40%;
  margin: 0 0 0 15px;
`;

export const perksAndBenefitsContainerStyles = css`
  margin: 32px 0 0 0;
`;

export const perksAndBenefitsLabelStyles = css`
  text-transform: capitalize;
  font-weight: 500;
`;

export const perksAndBenefitsCheckboxContainerStyles = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 400px;
  margin: 12px 0 0 0;
`;

export const perksAndBenefitsCheckboxStyles = css`
  width: 33%;
  margin: 0 0 10px 0;

  &:nth-of-type(15n) {
    margin: 0;
  }

  &:last-of-type {
    margin: 0;
  }
`;

export const addNewPerksAndBenefitsButtonStyles = css`
  margin: 10px 0 0 0;
  padding: 0;
  background-color: ${colors.TRANSPARENT};
  border: none;
  text-decoration: underline;
  font-size: 14px;
  color: ${colors.PRIMARY_YELLOWISH_ORANGE};
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.7;
  }
`;

export const cardFooterStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 72px;
`;

export const nextButtonStyles = css`
  margin: 0 0 0 20px;
`;
